/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type AdvancedRoadmapsSetupType from '@jira/spa-apps__advanced-roadmaps-setup/src/AdvancedRoadmapsSetupType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Setup Page
 */

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAdvancedRoadmapsSetup: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof AdvancedRoadmapsSetupType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-advanced-roadmaps-setup", jiraSpaEntry: "async-advanced-roadmaps-setup" */ '@jira/spa-apps__advanced-roadmaps-setup/src/AdvancedRoadmapsSetupType.tsx'
			),
		),
	{ ssr: false },
);

const AsyncAdvancedRoadmapsSetup = (): React.JSX.Element => (
	<LazyPage Page={LazyAdvancedRoadmapsSetup} pageId="advanced-roadmaps-setup" shouldShowSpinner />
);

export default AsyncAdvancedRoadmapsSetup;
